import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/text-cursor.vue
var o = {
	name: "DtIconTextCursor",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--text-cursor"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Text Cursor",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		d: "M6.94 1.94A1.5 1.5 0 0 1 8 1.5h.5a.5.5 0 1 0 0-1H8a2.5 2.5 0 0 0-2 1 2.5 2.5 0 0 0-2-1h-.5a.5.5 0 0 0 0 1H4A1.5 1.5 0 0 1 5.5 3v6A1.5 1.5 0 0 1 4 10.5h-.5a.5.5 0 0 0 0 1H4a2.5 2.5 0 0 0 2-1 2.507 2.507 0 0 0 2 1h.5a.5.5 0 0 0 0-1H8A1.5 1.5 0 0 1 6.5 9V3c0-.398.158-.78.44-1.06Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=text-cursor.js.map